import { Component, Input, OnInit } from "@angular/core";
import moment from "moment";
import { ManagerLogPostItem } from "src/app/shared/models/ManagerLogPost.item";

@Component({
	selector: "app-log-comment",
	templateUrl: "./log-comment.component.html",
	styleUrls: ["../../../../../commandcenter.scss"],
})
export class LogCommentComponent implements OnInit {
	@Input() managerLogPostSelected: ManagerLogPostItem;

	moment: any = moment;

	constructor() {}

	ngOnInit() {}
}
